"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const Place_1 = __importDefault(require("@mui/icons-material/Place"));
const Person_1 = __importDefault(require("@mui/icons-material/Person"));
const material_1 = require("@mui/material");
const services_1 = require("../../../common/services");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const BookingDetailModalSkeleton_1 = __importDefault(require("./BookingDetailModalSkeleton"));
const BookingDetailModalWrapper = styled_components_1.default.div `
  --lateral-padding: 16px;
  height: 100%;
  bottom: 0;
  background-color: #fff;

  display: flex;
  flex-direction: column;

  .description-content {
    flex-grow: 1;
    padding: 12px 0 0;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .scrollable-content {
    width: 100%;
    flex-grow: 1;
    height: 300px;
    overflow-y: auto;
    padding-inline: var(--lateral-padding);
    padding-bottom: 12px;
  }

  .section-title {
    color: #808080;
    margin-bottom: 5px;
  }

  .section-content-bold {
    font-weight: 500;
  }
`;
const BookingTitle = styled_components_1.default.div `
  margin: 0;
  padding-inline: var(--lateral-padding);
`;
const Location = styled_components_1.default.div `
  display: flex;
  color: #807e7e;
  margin: 12px 0;

  svg {
    position: relative;
    top: 2px;
    height: 18px;
  }

  span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
const Statuses = styled_components_1.default.div `
  margin: 20px 0;
  display: flex;

  .code {
    margin-right: 12px;
    padding: 8px;
    border-radius: 5px;
    background-color: #dfeeff;
  }

  .guest-number {
    margin-right: 12px;
    padding: 8px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    background-color: #dfeeff;

    svg {
      height: 18px;
      color: rgba(0, 0, 0, 0.87);
    }

    button {
      padding: 0;
    }
  }

  .booking-status {
    margin-right: 12px;
    padding: 8px;
    border-radius: 5px;
  }

  .booking-status-user_canceled {
    background-color: #ffe7e6;
  }
  .booking-status-confirmed {
    background-color: #e6fee0;
  }
`;
const TimeAndDate = styled_components_1.default.div `
  div {
    display: flex;
    justify-content: space-between;
  }
`;
const Field = styled_components_1.default.div `
  margin-top: 18px;
`;
const CancelBtnWrapper = styled_components_1.default.div `
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 8px;
  background-color: #fff;
  border-top: 1px solid rgba(46, 46, 46, 0.25);
  box-shadow: 0 -5px 5px -5px rgba(46, 46, 46, 0.25);
`;
const ImageHelper = styled_components_1.default.div `
  height: 250px;
`;
const ImageContainer = styled_components_1.default.div `
  height: 275px;
  width: 100%;
  background: linear-gradient(
    12deg,
    ${(props) => props.theme.palette.mainAppColor.dark} 5%,
    ${(props) => props.theme.palette.mainAppColor.light} 25%,
    ${(props) => props.theme.palette.mainAppColor.main} 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${(props) => {
    if (props.src) {
        return props.src;
    }
    return null;
}};
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const BookingDetailModalContent = ({ booking, fetchNewBookings, currentLocale, userData, timezone, }) => {
    const [bookingDetails, setBookingDetails] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [showDiscardDialog, setShowDiscardDialog] = (0, react_1.useState)(false);
    const [isBookingCanceled, setIsBookingCanceled] = (0, react_1.useState)(false);
    const [toast, setToast] = (0, react_1.useState)("");
    const getBookingDataAfterCancel = () => __awaiter(void 0, void 0, void 0, function* () {
        services_1.apiService
            .getBooking(currentLocale, booking.code, userData.token)
            .then((res) => {
            setBookingDetails(res.booking);
            setIsLoading(false);
        })
            .catch(() => {
            setIsLoading(false);
        });
    });
    const cancelBooking = () => __awaiter(void 0, void 0, void 0, function* () {
        yield services_1.apiService
            .cancelBooking(currentLocale, booking.code, userData.token)
            .then(() => {
            getBookingDataAfterCancel();
            setIsBookingCanceled(true);
        });
        fetchNewBookings();
    });
    const handleCancelBooking = (action = "") => {
        if (action === "confirm") {
            cancelBooking();
            setToast("Booking Cancelled");
        }
        setShowDiscardDialog(false);
    };
    const hideToast = () => {
        setToast("");
    };
    (0, react_1.useEffect)(() => {
        services_1.apiService
            .getBooking(currentLocale, booking.code, userData.token)
            .then((res) => {
            setBookingDetails(res.booking);
            setIsLoading(false);
        })
            .catch(() => {
            setIsLoading(false);
        });
    }, []);
    const bookingTypeData = bookingDetails && bookingDetails.bookable
        ? bookingDetails.bookable.activity ||
            bookingDetails.bookable.offer ||
            bookingDetails.bookable.page
        : null;
    const guestNr = getGuestNr(bookingTypeData);
    const timeRange = bookingDetails
        ? getTimeRange(bookingDetails.timeForDisplay, bookingDetails.endTimeForDisplay, currentLocale, timezone)
        : null;
    const fields = getFields(bookingTypeData, currentLocale, timezone);
    const imgUrl = bookingTypeData &&
        bookingTypeData.icon &&
        bookingTypeData.icon["2:1"] &&
        bookingTypeData.icon["2:1"].L
        ? `url( ${bookingTypeData.icon["2:1"].L} )`
        : null;
    const bookingDate = booking && booking.isoTime && helpers_1.Helpers.getDateFromStringDependingLocale(booking.isoTime, currentLocale, timezone).date;
    return (react_1.default.createElement(BookingDetailModalWrapper, null,
        react_1.default.createElement(ImageHelper, null,
            react_1.default.createElement(ImageContainer, { src: imgUrl })),
        react_1.default.createElement("div", { className: "description-content" }, isLoading ? (react_1.default.createElement(BookingDetailModalSkeleton_1.default, null)) : (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(BookingTitle, null,
                react_1.default.createElement(material_1.Typography, { variant: "h5" }, booking.title)),
            react_1.default.createElement("div", { className: "scrollable-content" },
                react_1.default.createElement(Location, null, bookingTypeData && bookingTypeData.placeName && (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(Place_1.default, null),
                    react_1.default.createElement(material_1.Typography, { variant: "body2" }, bookingTypeData.placeName)))),
                react_1.default.createElement(Statuses, null, bookingTypeData && (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement(material_1.Typography, { variant: "body2", className: "code" }, booking.code),
                    guestNr && (react_1.default.createElement("div", { className: "guest-number" },
                        react_1.default.createElement(Person_1.default, { color: "colorOnAppBar" }),
                        react_1.default.createElement(material_1.Typography, { variant: "body2" }, guestNr))),
                    bookingDetails && bookingDetails.stateForDisplay && (react_1.default.createElement(material_1.Typography, { variant: "body2", className: `booking-status booking-status-${bookingDetails.state}` }, bookingDetails.stateForDisplay))))),
                bookingDate && (react_1.default.createElement(TimeAndDate, null,
                    react_1.default.createElement(material_1.Typography, { variant: "body2", className: "section-title" }, i18n_js_1.default.t("date_and_time")),
                    react_1.default.createElement("div", { className: "section-content-bold" },
                        react_1.default.createElement(material_1.Typography, { variant: "body1", className: "section-content-bold" }, bookingDate),
                        timeRange && (react_1.default.createElement(material_1.Typography, { variant: "body1", className: "section-content-bold" }, timeRange))))),
                fields && fields)))),
        !isBookingCanceled && bookingDetails && bookingDetails.cancellable && (react_1.default.createElement(CancelBtnWrapper, null,
            react_1.default.createElement(material_1.Button, { fullWidth: true, onClick: () => setShowDiscardDialog(true), variant: "outlined", size: "large", color: "destroy" }, i18n_js_1.default.t("cancel_booking")),
            react_1.default.createElement(material_1.Typography, { paragraph: true, variant: "caption", align: "center", sx: { marginBottom: 0, marginTop: "5px" } }, i18n_js_1.default.t("booking_edit_hint")))),
        react_1.default.createElement(material_1.Snackbar, { onClose: hideToast, autoHideDuration: 2000, open: Boolean(toast), message: toast, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, className: "snackbar" }),
        react_1.default.createElement(material_1.Dialog, { open: showDiscardDialog, TransitionComponent: Transition, keepMounted: true, onClose: () => handleCancelBooking(), "aria-describedby": "alert-dialog-slide-description" },
            react_1.default.createElement(material_1.DialogTitle, null, i18n_js_1.default.t("booking_cancel_confirmation")),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { onClick: () => handleCancelBooking() }, i18n_js_1.default.t("cancel_booking_no_button")),
                react_1.default.createElement(material_1.Button, { onClick: () => handleCancelBooking("confirm") }, i18n_js_1.default.t("cancel_booking_yes_button"))))));
};
function getFields(bookingTypeData, currentLocale, timezone) {
    if (!bookingTypeData ||
        !bookingTypeData.availability ||
        !bookingTypeData.availability.fields) {
        return "";
    }
    const fields = bookingTypeData &&
        bookingTypeData.availability &&
        bookingTypeData.availability.fields;
    const filteredFieldValues = fields &&
        fields.filter((field) => field.id !== "pax" &&
            field.id !== "starts_at" &&
            field.id !== "ends_at");
    const fieldValues = filteredFieldValues &&
        filteredFieldValues.map((field) => {
            let displayValue = field.value;
            if (field.type === "datetime") {
                const { date, time } = helpers_1.Helpers.getDateFromStringDependingLocale(field.value, currentLocale, timezone);
                displayValue = `${date}, ${time}`;
            }
            if (field.type === "date") {
                displayValue = helpers_1.Helpers.getDateFromStringDependingLocale(field.value, currentLocale).date;
            }
            if (field.value) {
                return (react_1.default.createElement(Field, { key: field.id },
                    react_1.default.createElement(material_1.Typography, { variant: "body2", className: "section-title" }, field.label),
                    react_1.default.createElement(material_1.Typography, { variant: "body1", className: "section-content-bold" }, displayValue)));
            }
            return null;
        });
    return fieldValues;
}
function getGuestNr(bookingTypeData) {
    if (!bookingTypeData ||
        !bookingTypeData.availability ||
        !bookingTypeData.availability.fields) {
        return null;
    }
    let nr = null;
    bookingTypeData.availability.fields.forEach((field) => {
        if (field.id === "pax") {
            nr = field.value;
        }
    });
    return nr;
}
function getTimeRange(start, end, currentLocale, timezone) {
    if (!start && !end) {
        return null;
    }
    if (start && end) {
        return `${helpers_1.Helpers.getDateFromStringDependingLocale(start, currentLocale, timezone).time} - ${helpers_1.Helpers.getDateFromStringDependingLocale(end, currentLocale, timezone).time}`;
    }
    return helpers_1.Helpers.getDateFromStringDependingLocale(start, currentLocale, timezone).time;
}
const mapStoreToProps = (store) => ({
    timezone: store.getValue("timezone"),
    currentLocale: store.getValue("currentLocale"),
    userData: store.getValue("userData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(BookingDetailModalContent);
